<template>
    <div
        class="modal-with-header"
        role="dialog"
        aria-modal="true"
        :aria-label="label"
    >
        <div class="header">
            <slot name="header"></slot>

            <button
                class="close"
                type="button"
                data-qa="close-button"
                @click="$emit('close')"
            >
                Close
            </button>
        </div>

        <div class="modal-content-wrapper">
            <slot name="default"></slot>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router'

defineProps<{
    label: string
}>()

const emit = defineEmits<{
    close: []
}>()

const router = useRouter()
router.beforeEach(() => {
    emit('close')
})
</script>

<style lang="scss" scoped>
.modal-with-header {
    inset: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    // padding: 60px 0;
    position: absolute;
    background: $stone-3;

    // @include min-width(360) {
    padding: 100px 0;
    // }

    .header {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 64px;
        background: $stone-3;
        z-index: 1;

        .close {
            @include close-button;
        }
    }

    .modal-content-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: calc(100vh - 200px);
        height: 100%;
    }
}
</style>
